import { useEffect, useState, useRef } from "react";

import {
  Box,
  Button,
  Textarea,
  FormHelperText,
  Center,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { AllCategories } from "utils/constants";
import { AiOutlineArrowLeft } from "react-icons/ai";
import styled from "@emotion/styled";

import { useDispatch } from "react-redux";
import { getComposers } from "lib/redux/scripts/action";
import DOMPurify from "dompurify";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useQueryWrapper } from "services/apiHelper";
import { queryKeys } from "services/querykeys";
import { composersRequest } from "services/request";
interface NewScriptProps {
  onChange: (target) => void;
  handleFileUpload: (event) => void;
  handleSubmit: () => void;
  formData: any;
  isLoading: boolean;
  isEdit: boolean;
  setFormValues: any;
  formValues: any;
}
// interface composerListType {
//   name: string;
//   id: string;
// }
const NewScript = (props: NewScriptProps) => {
  const {
    isEdit,
    onChange,
    handleFileUpload,
    formData,
    handleSubmit,
    isLoading,
    // setFormValues,
    formValues,
  } = props;
  const { name, audioName, documentName, videoUrl, description, category, composerId } = formData;
  const editorRef = useRef<any>();
  const [editorLoaded, setEditorLoaded] = useState(false);
  const { CKEditor, ClassicEditor } = editorRef.current || {};

  useEffect(() => {
    editorRef.current = {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      CKEditor: require("@ckeditor/ckeditor5-react").CKEditor, // v3+
      ClassicEditor: require("@ckeditor/ckeditor5-build-classic"),
    };
    setEditorLoaded(true);
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getComposers());
  }, [dispatch]);

  const history = useNavigate();

  const onCKEditorChanged = (_, editor) => {
    const value = editor.getData();
    const clean = DOMPurify.sanitize(value, { USE_PROFILES: { html: true } });
    onChange({
      target: {
        name: "lyrics",
        value: clean,
      },
    });
  };
  const allCategories = AllCategories;

  const [allComposerObj, setAllComposerObj] = useState({});
  useQueryWrapper(queryKeys.COMPOSERS, composersRequest.COMPOSER, {
    refetchInterval: false,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const composerData = data?.data;
      const tempObj = {};
      const options = composerData.map((option) => {
        const composer = {
          value: option.id,
          label: option.name,
        };
        tempObj[option.id] = composer;
        return composer;
      });
      setAllComposerObj(tempObj);
      setReshapedComposer(options);
    },
  });
  const options: any = allCategories.map((option) => ({
    value: option,
    label: option,
  }));
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [reshapedComposer, setReshapedComposer] = useState([]);
  const [selectedComposer, setSelectedComposer] = useState(reshapedComposer[0]);
  useEffect(() => {
    const currCat = allCategories.indexOf(category);
    setSelectedOption(options[currCat]);

    const curComposer = allComposerObj[composerId];
    setSelectedComposer(curComposer);
  }, [category, reshapedComposer]);

  return (
    <Box>
      {isLoading && (
        <Center
          position="absolute"
          top="1px"
          bottom="0"
          left="0"
          right="0"
          width="100%"
          bg="blackAlpha.700"
          height="100%"
          mx="auto"
          zIndex="9"
        >
          <Flex flexDir="column" alignItems="center" justifyContent="center">
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="xl"
            />
            <Text mt={4} color="#fff">
              Uploading file please wait...
            </Text>
          </Flex>
        </Center>
      )}
      <Button
        m={4}
        leftIcon={<AiOutlineArrowLeft />}
        onClick={() => {
          history(-1);
        }}
      >
        {" "}
        Back
      </Button>
      <Text textAlign="center" fontSize="3xl" color="blackAlpha.700">
        {isEdit ? "Update Script" : " New Script"}
      </Text>
      {isEdit && (
        <Text px="4" textAlign="center" fontSize="12px" color="orangered">
          Note: You can not update Image/PDF and Audio as this is equivalent to creating a new
          script
        </Text>
      )}
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Container
          overflow={{ base: "auto", lg: "unset" }}
          p={4}
          maxWidth="800px"
          position="relative"
        >
          <Grid
            templateColumns={{
              base: "repeat(1, 1fr)",
              lg: "repeat(2, 1fr)",
            }}
            gap={8}
          >
            <Box>
              <FormControl id="scriptName" isRequired mb={4}>
                <FormLabel mb={1}>Script Name</FormLabel>
                <Input
                  type="text"
                  _focus={{ boxShadow: "none" }}
                  name="name"
                  placeholder="Eg Blessed Assurance"
                  value={name}
                  onChange={onChange}
                  autoComplete="off"
                />
              </FormControl>

              <FormControl id="category" isRequired mb={4}>
                <FormLabel mb={1}>Category</FormLabel>
                <Select
                  options={options}
                  value={selectedOption}
                  onChange={(option) => {
                    setSelectedOption(option);
                    onChange({
                      target: {
                        name: "category",
                        value: option.value,
                      },
                    });
                  }}
                />
              </FormControl>
              <FormControl id="composerName" isRequired mb={4}>
                <FormLabel>Composer</FormLabel>
                <ComposerListWrapper>
                  <Select
                    options={reshapedComposer}
                    value={selectedComposer}
                    onChange={(option: any) => {
                      // setCurrentSearch(value);
                      onChange({
                        target: {
                          name: "composerId",
                          value: option?.value,
                        },
                      });
                    }}
                  />
                </ComposerListWrapper>
                <FormHelperText m={0}>You can select unknown</FormHelperText>
              </FormControl>

              <FormControl id="videoUrl" mb={4}>
                <FormLabel mb={1}>Video Url</FormLabel>
                <Input
                  type="text"
                  _focus={{ boxShadow: "none" }}
                  placeholder="Optional Youtube video"
                  name="videoUrl"
                  value={videoUrl}
                  onChange={onChange}
                />
              </FormControl>
              <FormControl id="description" mb={4}>
                <FormLabel m={0}>Description</FormLabel>
                <Textarea
                  size="lg"
                  placeholder="Optional description"
                  resize="none"
                  bg="#fff"
                  borderWidth="1px"
                  borderColor="#dbe3e9"
                  padding="7px 16px"
                  fontSize="14px"
                  mt={1}
                  outline="none"
                  _focus={{ outline: "none" }}
                  name="description"
                  value={description}
                  onChange={onChange}
                  maxLength={2000}
                />
                <Flex justifyContent="space-between">
                  <FormHelperText m={0}>This will be shown on Google</FormHelperText>

                  <Text fontSize="13px" color="#7f94a6" textAlign="right">
                    {description.length}/2,000 characters
                  </Text>
                </Flex>
              </FormControl>
              <Box maxW="368px" mt="2">
                <FormLabel m={0}>Lyrics</FormLabel>
                {editorLoaded ? (
                  <CKEditor
                    editor={ClassicEditor}
                    data={formValues.lyrics}
                    onReady={(editor) => {
                      isEdit && formValues.lyrics && editor.setData(formValues.lyrics);
                    }}
                    onChange={onCKEditorChanged}
                  />
                ) : (
                  <Box>Editor is Loading</Box>
                )}
              </Box>
            </Box>
            <Box>
              <FormControl id="image" isRequired mb={4}>
                <FormLabel mb={1}>Script Image/PDF</FormLabel>
                <Flex>
                  <Input
                    type="file"
                    name="document"
                    id="actual-btn"
                    onChange={handleFileUpload}
                    accept="image/*, .pdf"
                    display="none"
                  />

                  <Input
                    type="text"
                    _focus={{ boxShadow: "none" }}
                    placeholder="Choose a file"
                    value={documentName}
                    readOnly
                    rounded={0}
                    borderLeftRadius="md"
                  />
                  <Button
                    onClick={() => {
                      document.getElementById("actual-btn")?.click();
                    }}
                    rounded={0}
                    borderRightRadius="md"
                    boxShadow="md"
                  >
                    Browse
                  </Button>
                </Flex>
              </FormControl>

              <FormControl id="audio" mb={4}>
                <FormLabel mb={1}>Audio (Optional)</FormLabel>
                <Flex>
                  <Input
                    type="file"
                    id="audio-btn"
                    name="audio"
                    onChange={handleFileUpload}
                    accept="audio/*"
                    display="none"
                  />

                  <Input
                    type="text"
                    _focus={{ boxShadow: "none" }}
                    placeholder="Choose an audio file"
                    value={audioName}
                    readOnly
                    rounded={0}
                    borderLeftRadius="md"
                  />
                  <Button
                    onClick={() => {
                      document.getElementById("audio-btn")?.click();
                    }}
                    rounded={0}
                    borderRightRadius="md"
                    boxShadow="md"
                  >
                    Browse
                  </Button>
                </Flex>
              </FormControl>
            </Box>
          </Grid>
          <Box textAlign="right" mt={4}>
            <Button
              variant="secondaryOutline"
              mr={4}
              onClick={() => {
                history(-1);
              }}
            >
              Cancel
            </Button>
            <Button onClick={handleSubmit}>{isEdit ? "Update" : "Upload"} </Button>
          </Box>
        </Container>
      </form>
    </Box>
  );
};
const ComposerListWrapper = styled.div`
  position: relative;
  .customer-list {
    display: none;
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 10rem;
    background-color: #f9f9f9;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    overflow-x: auto;
    h6 {
      padding: 12px 16px;
    }
    button {
      all: unset;
      display: block;
      padding: 12px 16px;
      width: 90%;
      text-transform: capitalize;
      :hover {
        background-color: #f1f1f1;
        cursor: pointer;
      }
    }
    .nothing {
      /* background-color:red; */
      width: 100%;
      /* height:100%; */
      img {
        height: 100%;
        max-height: 110px;
      }
    }
  }
  .active {
    display: block;
  }
`;
export default NewScript;
